<template>
  <v-card class="overflow-y-auto">
    <!-- <v-window v-model="step" v-if="questionsDetails.length>0">  -->
    <div>
      <v-toolbar height="32" tile color="appBar" flat>
        <v-spacer></v-spacer>
        <v-btn color="pageHeader" text class="vueexcelbtn">
          <vue-excel-xlsx
            :disabled="rowDataWithSections.length ? false : true"
            :data="rowDataWithSections"
            :columns="headingColumns"
            :file-name="filename"
            :file-type="'xlsx'"
            :sheet-name="'Responses'"
          >
            <v-icon :color="rowDataWithSections.length ? 'green darken-2' : 'grey darken-2'">mdi-microsoft-excel</v-icon>
            {{ $t("poll.lblOpenExcel") }}
          </vue-excel-xlsx>
        </v-btn>
      </v-toolbar>
      <v-divider style="border-color: gray"></v-divider>
      <template v-for="(section, sectionIndex) in sectionList">
        <!-- <v-window-item
          :value="sectionIndex"
          :key="sectionIndex"
          class="pa-0 ma-0"
        > -->
        <div :key="sectionIndex">
          <div class="section-panel">
            <div class="section-header">
              <h2 class="pl-4 pb-2 pt-2">
                <v-chip
                  small
                  class="mb-1"
                  color="Neutral"
                  style="border: 1px solid var(--v-secondary-base) !important"
                  >{{ $t("poll.lblSection") }} {{ sectionIndex + 1 }}</v-chip
                >
                <span class="white--text ml-2">{{ section.title }}</span>
              </h2>
              
            </div>
            <div class="ma-4" v-html="$sanitizeHtml(section.description)"></div>
          </div>
          <template v-for="(question, index) in section.questions">
            <div :key="`res-${question.number}-${index}`">
              <v-row class="mb-4 mt-4" no-gutters>
                <v-col
                  md="11"
                  class="pl-4 text-h6 font-weight-regular"
                  >
                  {{ section.prevQuestionCount + index + 1 }}.
                    <span v-html="questionText(question.question)" ></span> 
                    <v-tooltip top v-if="question.isMandatory">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs"
                        v-on="on" v-if="question.isMandatory" style="color: red" class="ml-1">
                          *
                        </span>
                      </template>
                      <span>{{ $t("poll.ruleRequired") }} </span>
                    </v-tooltip>
                </v-col>
                <v-col
                    md="1"
                    class="text-center"
                  >
                    <v-btn
                    icon
                      color="grey"
                      small
                      depressed
                      @click="toggleExpand(question.id)"
                      >
                      <v-icon>
                        {{ expandedIds.includes(question.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                    </v-btn>
                  </v-col>
              </v-row>
              <transition
                name="slide"
                @before-enter="beforeEnter"
                @enter="enter"
                @leave="leave"
              >
              <v-card-text class="pt-1" v-if="!expandedIds.includes(question.id)">
                <likert-response-chart
                  v-if="question.type === 'likert'"
                  :question="question"
                  :countOptionAnswers="
                    likertResponseData[question.id]
                      ? likertResponseData[question.id].optionCounts
                      : []
                  "
                  :responseCount="
                    likertResponseData[question.id]
                      ? likertResponseData[question.id].count
                      : 0
                  "
                ></likert-response-chart>
                <text-response
                  v-else-if="question.type === 'textType'"
                  :question="question"
                  :textResponse="textResponses[question.id]"
                >
                </text-response>
                <rating-response
                  v-else-if="question.type === 'rating'"
                  :question="question"
                  :ratingData="ratingData[question.id]"
                ></rating-response>
                <v-row v-else-if="question.type === 'choice'" no-gutters>
                  <v-col cols="8" no-gutters>
                    <v-list>
                      <v-list-item
                        v-for="(option, i) in question.options"
                        :key="`list_${option}_${i}`"
                        class="group-item-list"
                      >
                        <!-- {{ option }} -->
                        <v-list-item-content class="font-weight-medium">
                          <v-layout>
                            <v-row align="center">
                              <v-col cols="auto">
                                <v-row no-gutters justify="start">
                                  <v-sheet
                                    :rounded="radius"
                                    :color="option.fill"
                                    height="20"
                                    width="20"
                                  ></v-sheet>
                                </v-row>
                              </v-col>
                              <v-col cols="auto">
                                <v-row no-gutters justify="start"
                                  ><span class="expire-label"
                                    >{{ option.text }}
                                  </span></v-row
                                >
                              </v-col>
                              <v-col cols="auto">
                                <v-row
                                  no-gutters
                                  justify="start"
                                  v-if="countOptionAnswers[question.id]"
                                >
                                  {{
                                    countOptionAnswers[question.id]
                                      .optionCounts[option.value]
                                  }}
                                </v-row>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-layout>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col cols="4">
                    <survey-response-chart
                      :question="question"
                      v-if="countOptionAnswers[question.id]"
                      :countOptionAnswers="
                        countOptionAnswers[question.id].optionCounts
                      "
                      :responseCount="
                        countOptionAnswers[question.id]
                          ? countOptionAnswers[question.id].count
                          : 0
                      "
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </transition>
            <v-divider class="mx-4"></v-divider>
            </div>
          </template>
          <!-- </v-window-item> -->
        </div>
      </template>
      <!-- </v-window> -->
    </div>
    <v-card-actions v-if="questionsDetails.length > 0 && false">
      <v-btn
        class="ma-3"
        small
        rounded
        color="secondary"
        :disabled="step === 0"
        @click="back"
      >
        {{ $t("Back") }}
      </v-btn>

      <div style="width: 300px">
        <v-progress-linear
          :value="((step + 1) / sections.length) * 100"
          height="28"
          color="secondary"
          dark
          rounded
        >
          <strong>{{ step + 1 }}/{{ sections.length }}</strong>
        </v-progress-linear>
      </div>
      <v-btn
        class="ma-3"
        rounded
        :disabled="step === sections.length - 1"
        small
        color="secondary"
        depressed
        @click="next"
      >
        {{ $t("Next") }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LikertResponseChart from "./LikertResponseChart.vue";
import RatingResponse from "./RatingResponse.vue";
import TextResponse from "./TextResponse.vue";
import SurveyResponseChart from "./SurveyResponseChart.vue";
import VueExcelXlsx from "vue-excel-xlsx";
import SignalRMixin from "../../mixin/SignalRMixin";
import Vue from "vue";
import _ from "lodash";
import { formatDate } from "@/utils/util";

Vue.use(VueExcelXlsx);
const exlColumns = [
  {
    label: "ID",
    field: "id",
  },
  {
    label: "Submit Date",
    field: "submitDate",
  },
  {
    label: "User ID",
    field: "userid",
  },
];
export default {
  components: {
    SurveyResponseChart,
    RatingResponse,
    LikertResponseChart,
    TextResponse,
  },
  name: "SurveyResponse",
  mixins: [SignalRMixin],
  props: {
    surveyQuestions: {
      type: [Object, Array],
    },
    tab: {
      type: String,
      default: 'question',
    },
  },
  computed: {
    ...mapState({
      surveyResponseResult: (state) => state.poll.surveyResponseResult,
      surveyCompairResult: (state) => state.poll.surveyCompairResult,
    }),
    questionsDetails() {
      return this.surveyResponseData;
    },
    surveyResponseSummaryResult(){
      if(this.tab === "result-summary" && this.surveyCompairResult.length){
        return this.surveyCompairResult;
      }
      return this.surveyResponseResult;
    },
    sections() {
      return this.surveyQuestions ? this.surveyQuestions.sections : [];
    },
    sectionList() {
      let index = 0;
      let res = [];
      this.sections.forEach((s) => {
        let questions = this.getQuestionsForSection(s.sectionId);
        res.push({
          ...s,
          questions: questions,
          prevQuestionCount: index,
        });
        index = index + questions.length;
      });
      return res;
    },
    ratingResponses() {
      let responseList = [];
      let index = 1;
      this.surveyResponseData.forEach((quest) => {});
      if (responseList.length > 1 && !this.selectedResponse) {
        this.selectedResponse = responseList[0];
      }
      return responseList;
    },
    filename() {
      return this.surveyQuestions?.title;
    },
    headingColumns() {
      const headers = [];
      let index = 0;
      this.sectionList.forEach((section, secindex) => {
        section.questions.forEach((question, queindex) => {
          if (question.type === "likert") {
            question.options.statement.forEach((stmt) => {
              headers.push({
                label: index + 1 + ". " + question.question + "\n" + stmt.text,
                field: index + 1 + stmt.text,
              });
            });
          } else {
            headers.push({
              label: index + 1 + ". " + question.question,
              field: "Question" + (index + 1),
            });
          }
          index = index + 1;
        });
      });

      return [...exlColumns, ...headers];
    },
    rowDataWithSections() {
      let index = 1;
      const rowData = [];
    if(this.surveyResponseSummaryResult && this.surveyResponseSummaryResult.length > 0){
      this.surveyResponseSummaryResult.forEach((res) => {
        let rowIndex = 0;
        let js = {};
        js.id = index.toString();
        const submitDate = this.formatDate(
          new Date(res.submitDate),
          this.displayDateFormat
        );
        js.submitDate = submitDate;

        // js.submitDate = res.submitDate;
        const useName = res.userName
          ? `${res.userName} (${res.userid})`
          : res.userid;
        if (this.surveyQuestions && 
          "isAnonymous" in this.surveyQuestions &&
          this.surveyQuestions.isAnonymous
        ) {
          js.userid = this.$t("poll.lblUserRespondent", { number: index });
        } else {
          js.userid = useName;
        }

        this.sectionList.forEach((section, secindex) => {
          Array.from(section.questions).forEach((question, queindex) => {
            const queIndex = rowIndex + 1;
            const data = res.questionAnswers.findIndex(
              (x) => x.questionId === question.id
            );
            if (data > -1) {
              if (question.type === "likert") {
                Array.from(res.questionAnswers[data].answer).forEach((ans) => {
                  const ansdata = question.options.options.findIndex(
                    (x) => x.value === ans.value
                  );
                  if (ansdata > -1) {
                    const comment = ans.comment ? `Comment: ${ans.comment}` : "";
                    const text = `${question.options.options[ansdata].text}${comment ? `  \n${comment}` : ""}`;
                    js[queIndex + ans.text] =  text;
                  }
                });
              } else if (
                question.type === "choice" &&
                question.isMultipleAnswer === false
              ) {
                const ansdata = question.options.find(
                  (x) => x.value === res.questionAnswers[data].answer
                );
                if (ansdata) {
                  js["Question" + queIndex] = ansdata.text;
                }
              } else if (
                question.type === "choice" &&
                question.isMultipleAnswer === true
              ) {
                let str = [];
                Array.from(res.questionAnswers[data].answer).forEach((ans) => {
                  const ansdata = question.options.find((x) => x.value === ans);
                  if (ansdata) {
                    str.push(ansdata.text);
                  }
                });
                js["Question" + queIndex] = str.join(", ");
              } else {
                js["Question" + queIndex] = res.questionAnswers[data].answer
                  ? res.questionAnswers[data].answer.toString()
                  : "";
              }
            }
            rowIndex = rowIndex + 1;
          });
        });
        rowData.push(js);
        index = index + 1;
      });
    }
      return rowData;
    },
    rowData() {
      let index = 1;
      const rowData = [];
    if(this.surveyQuestions && this.surveyResponseSummaryResult && this.surveyResponseSummaryResult.length > 0){
      this.surveyResponseSummaryResult.forEach((res) => {
        let js = {};
        js.id = index.toString();
        js.submitDate = res.submitDate;
        const useName = res.userName
          ? `${res.userName} (${res.userid})`
          : res.userid;
        if ("isAnonymous" in this.surveyQuestions &&
          this.surveyQuestions.isAnonymous
        ) {
          js.userid = this.$t("poll.lblUserRespondent", { number: index });
        } else {
          js.userid = useName;
        }

        this.surveyQuestions.questions.forEach((question, rowIndex) => {
          const queIndex = rowIndex + 1;
          const data = res.questionAnswers.findIndex(
            (x) => x.questionId === question.id
          );
          if (data > -1) {
            if (question.type === "likert") {
              Array.from(res.questionAnswers[data].answer).forEach((ans) => {
                const ansdata = question.options.options.findIndex(
                  (x) => x.value === ans.value
                );
                if (ansdata > -1) {
                  js[queIndex + ans.text] =
                    question.options.options[ansdata].text;
                }
              });
            } else if (
              question.type === "choice" &&
              question.isMultipleAnswer === false
            ) {
              const ansdata = question.options.find(
                (x) => x.value === res.questionAnswers[data].answer
              );
              if (ansdata) {
                js["Question" + queIndex] = ansdata.text;
              }
            } else if (
              question.type === "choice" &&
              question.isMultipleAnswer === true
            ) {
              let str = [];
              Array.from(res.questionAnswers[data].answer).forEach((ans) => {
                const ansdata = question.options.find((x) => x.value === ans);
                if (ansdata) {
                  str.push(ansdata.text);
                }
              });
              js["Question" + queIndex] = str.join(", ");
            } else {
              js["Question" + queIndex] = res.questionAnswers[data].answer
                ? res.questionAnswers[data].answer.toString()
                : "";
            }
          }
        });
        rowData.push(js);
        index = index + 1;
      });
    }
      return rowData;
    },
    locale() {
      return this.$i18n.locale;
    },
    displayDateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy h:mm aaa" : "yyyy-MM-dd HH:mm";
    },
  },
  data: () => ({
    surveyResponseData: [],
    textResponses: {},
    countOptionAnswers: {},
    likertResponseData: {},
    ratingData: {},
    radius: "circle",
    step: 0,
    menuMaxHeight: `${60 * 5 + 4}px`,

    columns: [
      {
        label: "ID",
        field: "id",
      },
      {
        label: "Submit Date",
        field: "submitDate",
      },
      {
        label: "User ID",
        field: "userid",
      },
    ],
    data: [],
    expandedIds: []
  }),
  watch: {
    "surveyQuestions.id": {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue) {
          await this.analyseResponse(newValue);
        }
      },
    },
  },
  async mounted() {},
  async created() {
    this.$root.$on("refresh-signalR", async () => {
      await this.analyseResponse(this.$route.params.id);
    });
  },
  beforeDestroy() {
    this.$root.$off("refresh-signalR");
  },
  methods: {
    ...mapActions({
      getResponseBySurveyId: "poll/getResponseBySurveyId",
    }),
    formatDate,
    back() {
      this.step--;
      window.scrollTo(0, 0);
    },
    next() {
      this.step++;
      window.scrollTo(0, 0);
    },
    getQuestionsForSection(sectionid) {
      return this.questionsDetails
        ? this.questionsDetails.filter((f) => f.sectionId === sectionid)
        : [];
    },
    async updateRespondentResult() {
      const surveyQuestionsData = _.cloneDeep(this.surveyQuestions);
      if(this.surveyResponseSummaryResult && this.surveyResponseSummaryResult.length > 0){
        this.surveyResponseSummaryResult.forEach((surveyResponse) => {
          surveyQuestionsData.questions.forEach((question) => {
            const data = surveyResponse.questionAnswers.findIndex(
              (x) => x.questionId === question.id
            );
            if (data > -1) {
              question.selectedAnswer =
                surveyResponse.questionAnswers[data].answer;
            }
          });
        });
      }
      this.surveyResponseData = surveyQuestionsData
        ? surveyQuestionsData.questions
        : [];
    },
    async analyseResponse(id) {
      const data = this.surveyResponseSummaryResult;
      let temp = [];
      let resCount = data.length;
      if(data && data.length > 0){
      const questionAnswers = data.map((d) => d.questionAnswers);
      questionAnswers.forEach((answer) => {
        //const questions = answer.map((a) => a.answer);
        answer.forEach((list) => {
          if (Array.isArray(list.answer)) {
            list.answer.forEach((q) => {
              temp.push({
                answer: q,
                type: list.type,
                questionId: list.questionId,
              });
            });
          } else {
            temp.push({
              answer: list.answer,
              type: list.type,
              questionId: list.questionId,
            });
          }
        });
      });
      }
      this.countOptionAnswers = {};
      this.ratingData = {};
      this.textResponses = {};
      let total = {};
      let responseCount = {};
      let countOptions = {};
      let textIndex = 0;
      let textRes = [];
      let likertResponseCount = {};
      let likertResponse = {};
      let likertValues = [];
      const questionAnswerResponse = temp.filter((t) => t.answer !== null);
      questionAnswerResponse.forEach((element) => {
        responseCount[element.questionId] =
          (responseCount[element.questionId] || 0) + 1;

        let count = responseCount[element.questionId];

        if (element.type === "choice") {
          countOptions[element.answer] =
            (countOptions[element.answer] || 0) + 1;

          this.countOptionAnswers[element.questionId] = {
            optionCounts: countOptions,
            count: count,
          };
        } else if (element.type === "likert") {
          likertResponseCount[element.questionId] =
            (likertResponseCount[element.questionId] || 0) + 1;

          likertValues.push({
            text: element.answer.text,
            value: element.answer.value,
            questionId: element.questionId,
          });
          //likertResponse[element.answer.text] =
          //optionCounts

          this.likertResponseData[element.questionId] = {
            optionCounts: likertValues.filter(
              (f) => f.questionId === element.questionId
            ),
            count: resCount,
          };
        } else if (element.type === "rating") {
          total[element.questionId] =
            (total[element.questionId] || 0) + element.answer;

          this.ratingData[element.questionId] = {
            count: count,
            avg: (total[element.questionId] / count).toFixed(2),
          };
        } else if (element.type === "textType") {
          textRes.push({
            questionId: element.questionId,
            text: element.answer,
          });
          this.textResponses[element.questionId] = textRes
            .filter((f) => f.questionId === element.questionId)
            .map((a) => a.text);
        } else {
          countOptions[element.answer] =
            (countOptions[element.answer] || 0) + 1;

          this.countOptionAnswers[element.questionId] = {
            optionCounts: countOptions,
            count: count,
          };
        }
      });
      await this.updateRespondentResult();
    },
    questionText(html){
      const htmlContent = html.replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
      const content = htmlContent ? htmlContent.replace(/\n/g, '<br>') : ''
      return this.$sanitizeHtml(content)
    },
    toggleExpand(id) {
      const index = this.expandedIds.indexOf(id);
      if (index === -1) {
        // Add the ID if not present
        this.expandedIds.push(id);
      } else {
        // Remove the ID if already present
        this.expandedIds.splice(index, 1);
      }
    },
    beforeEnter(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    },
    enter(el, done) {
      const height = el.scrollHeight;
      el.style.height = `${height}px`;
      el.style.opacity = '1';
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      setTimeout(() => {
        el.style.height = 'auto';
        done();
      }, 300);
    },
    leave(el, done) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.opacity = '1';
      setTimeout(() => {
        el.style.height = '0';
        el.style.opacity = '0';
        el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
        done();
      }, 0);
    }
  },
};
</script>

<style scoped>
::v-deep .section-header {
  background-color: var(--v-primary-base);
  border-bottom: solid 1px lightgray;
}

::v-deep .section-panel {
  background-color: rgb(246, 247, 248);
  border: solid 1px lightgray;
}

.border {
  border: 1px solid gray;
}

.group-item-list {
  margin-top: 2px;
  margin-bottom: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}

.expire-label {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.vote-label {
  font-size: 0.688rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: darkblue;
}

.v-list-item-group .v-list-item--active {
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter, 
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.vueexcelbtn /deep/ button:disabled{
  background-color: #e0e0e0;  /* light grey background */
  color: #9e9e9e;             /* grey text */
  border-color: #ccc;         /* optional: adjust border too */
  cursor: not-allowed;
}
</style>